<template>
	<div class="chat-window">
		<div class="chat-title" v-if="val.groupName">{{ val.groupName }}</div>
		<div class="chat-title" v-else>暂无</div>
		<div class="chat-container" ref="chatContainer">
			<!-- <spider-window-friendmessage /> -->
			<spider-window-mymessage ref="SpiderWindowMymessage" @scrpllEnd="toEnd" />
			<!-- :message="allMsgArr" -->
		</div>
		<!-- 发送的输入框 -->
		<spider-send-box :targetUser="val" @sendSuccess="sendSuccess" />
	</div>
</template>

<script>
	import SpiderSendBox from "../spider-send/spider-send-box.vue";
	import spiderWindowFriendmessage from "./spider-window-friendmessage.vue";
	import SpiderWindowMymessage from "./spider-window-mymessage.vue";
	import SpiderWindowTime from "./spider-window-time.vue";
	// import init from "@/assets/js/rongyun.js";
	import {
		mapState
	} from "vuex";
	// const userInfo = {
	//   token:
	//     "Oi1v2hDJnsU+O6a1rNyW6eVuqMnjL/Jr7fScDl/ZhUP4UruHdt/k95PgPVCwC2SJ@semu.cn.rongnav.com;semu.cn.rongcfg.com",
	//   appKey: "cpj2xarlcmoin",
	// };
	export default {
		components: {
			spiderWindowFriendmessage,
			SpiderWindowMymessage,
			SpiderWindowTime,
			SpiderSendBox,
		},
		data() {
			return {
				loginMsg: {}, //所有信息
				userInfo: {}, //融云实例化实例化本账号的用户信息
				sendMsg: [], //发送的信息
				receiveMsg: [], //接收的信息
				val: {}, //选中的目标群组或者人
				allMsgArr: [], //全部的消息  分开写得话很难去操作 收发顺序 目前统一都在spider-window-mymessage去处理
			};
		},
		computed: {
			...mapState({
				//获取到vuex融云实例化的数据
				RongIMClient: (state) => state.rongyun.RongIMClient,
				targetId: (state) => state.rongyun.targetId, //当前聊天的目标id
			}),
		},
		created() {
			let userInfo = JSON.parse(localStorage.getItem("loginMsg")); //存在缓存的用户信息
			this.loginMsg = userInfo; //用户信息
			// this.userInfo.appKey = "k51hidwqkg3nb"; //appkey
			// this.userInfo.token = userInfo.tripartiteToken;
		},
		watch: {
			//监听targetId 正在聊天的目标id
			targetId(newVal, oldVal) {
				oldVal = newVal;
			},
		},
		mounted() {
			console.log('spider-window-messagebox组件已挂载');
		},
		methods: {
			//传过来的值 秘书台
			init(val) {
				return new Promise((resolve) => {
					this.sendMsg = []; //初始化清空发送的消息
					this.receiveMsg = []; //初始化清空接收的消息
					this.allMsgArr = []; //初始化全部消息清空
					this.$refs.SpiderWindowMymessage.changeFirstStatus();
					if (val) {
						this.val = val;
					}
					this.val.groupName = this.val.groupName ?
						this.val.groupName :
						this.val.nickName;
						
					// 设置当前聊天目标ID，用于后续判断是否需要显示红点
					if (this.val && this.val.targetId) {
						this.$store.commit('setTargetId', this.val.targetId);
					}
					
					this.watchM(); //监听
					// this.getUnreadNum(); //获取未读信息
					//初始化聊天信息
					console.log('初始化spider-window-mymessage组件');
					console.log(`当前聊天目标ID: ${this.val.targetId}`);
					this.$refs.SpiderWindowMymessage.init(this.val, this.loginMsg);
					console.log('spider-window-mymessage组件初始化完成');
					// 监听group-message-in-chat事件，用于接收新消息
					this.$root.$on('group-message-in-chat', (message) => {
						console.log('spider-window-messagebox收到group-message-in-chat事件:', message);
						if (this.$refs.SpiderWindowMymessage) {
							console.log('spider-window-messagebox: 转发消息到spider-window-mymessage组件');
							this.$refs.SpiderWindowMymessage.handleGroupMessageInChat(message);
						}
					});
					
					// 清除当前会话的未读消息
					this.clearConversationUnread().then(() => {
						resolve(); // 初始化完成
					});
				});
			},
			//聊天框滚动到底部
			toEnd() {
				this.$nextTick(() => {
					// let middle = this.$refs["chatContainer"];
					// middle.scrollTop = middle.scrollHeight;

					const container = this.$refs.chatContainer;
					if (container) {
						container.scrollTo({
							top: container.scrollHeight,
							behavior: 'smooth'
						});
					}
				});
			},
			//发送成功传来的值
		sendSuccess(val) {
			// 标记为本地发送的消息，避免重复添加
			val.localMessage = true;
			this.$refs.SpiderWindowMymessage.addSendMsg(val);
			// 在消息发送成功后触发滚动
			this.toEnd();
			// 通知私信列表刷新最新消息
			this.$root.$emit('private-message-sent', val);
			// this.sendMsg.push(val);
			// this.allMsgArr.push(Object.assign(val, this.loginMsg));
			// this.$store.dispatch("changeMsgNum", this);
		},
			//获取未读消息
			getUnreadNum() {
				const conversationTypes = [window.RongIMLib.CONVERSATION_TYPE.GROUP];
				this.RongIMClient.Conversation.getTotalUnreadCount(
					false,
					conversationTypes
				).then(function(totalUnreadCount) {
					// console.log("获取未读总数成功", totalUnreadCount);
				});
			},
			
			// 清除当前会话的未读消息
			clearConversationUnread() {
				return new Promise((resolve) => {
					if (!this.val || !this.val.targetId) {
						resolve(); // 如果没有目标ID，直接resolve
						return;
					}
					
					// 获取当前会话
					const conversation = this.RongIMClient.Conversation.get({
						targetId: this.val.targetId,
						type: this.val.from === "person" ? 
							window.RongIMLib.CONVERSATION_TYPE.PRIVATE : 
							window.RongIMLib.CONVERSATION_TYPE.GROUP,
					});
					
					// 标记为已读
					conversation.read().then(() => {
						console.log("清除当前会话未读消息成功");
						resolve();
					}).catch(error => {
						console.error("清除未读消息失败:", error);
						resolve();
					});
				});
			},
			//slider-bar 是主要链接融云的地方 但是会在spider-window-messagebox文件从新再连接 就是点击了某个人或者群组聊天的时候 有些值会修改的方便些
			// 消息监听已移至secretaryStation/index.vue中统一处理
		watchM() {
			// 移除重复的消息监听器，避免红包消息重复显示
		},
		},
	};
</script>

<style scoped>
	.chat-window {
		min-width: 506px;
		flex: 1;
		display: flex;
		flex-direction: column;
		background: #f5f7fa;
		border-left: 1px solid #dcdfe6;
		overflow: auto;
	}

	.chat-window .chat-title {
		width: 100%;
		flex-shrink: 0;
		display: flex;
		align-items: center;
		height: 60px;
		font-size: 18px;
		color: #313233;
		letter-spacing: 2px;
		padding: 0 20px;
		background: #f5f7fa;
		box-sizing: border-box;
		border-bottom: 1px solid #dcdfe6;
	}

	.chat-window .chat-container {
		min-height: 100px;
		height: 100%;
		padding: 20px;
		box-sizing: border-box;
		border-bottom: 1px solid #dcdfe6;
		overflow-y: auto;
	}
	.chat-container {
		overflow-y: auto;
		-webkit-overflow-scrolling: touch; /* 启用iOS惯性滚动 */
		scroll-behavior: smooth; /* 启用平滑滚动 */
	}
</style>